module.exports = __webpack_public_path__ + "img/add-benefits.a607e24c.svg";